import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onBeforeMount, ref } from 'vue';
import { GenericPodProduct, GenericPodVariant } from '@/api/typings/podProviders';
import SelectTable from '@/components/SelectTable/SelectTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariantPicker',
  props: {
    selectedProduct: null
  },
  emits: ["variant-selected", "cancel"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'variant-selected', value: GenericPodVariant): void;
    (event: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    selectedProduct: GenericPodProduct;
};





const tableFields = [{ key: 'title', label: 'Variant' }, 'actions'];
const productPerPage = 10;
const currentPage = ref(1);
const totalCount = ref(10);
const searchVal = ref('');
const filteredItems: Ref<GenericPodVariant[]> = ref([]);
const selectedVariant: Ref<GenericPodVariant | null> = ref(null);

const formattedOptionName = computed(() => {
    return (value: string) => {
        const title = value.replace(/([A-Z])/g, ' $1');
        return `${title.charAt(0).toUpperCase()}${title.slice(1)}`;
    };
});

onBeforeMount(() => {
    onFilterChange(1);
});

const onFilterChange = (pageNumber: number) => {
    let variants = JSON.parse(JSON.stringify(props.selectedProduct.variants)) as GenericPodVariant[];
    currentPage.value = pageNumber;
    const startIndex = (pageNumber - 1) * productPerPage;
    const endIndex = startIndex + productPerPage;

    if (searchVal.value?.length) {
        variants = variants.filter((v) => v.title.toLowerCase().includes(searchVal.value.toLowerCase()));
    }

    totalCount.value = variants.length;
    filteredItems.value = variants.slice(startIndex, endIndex);
};

const onVariantSelected = (value: unknown) => {
    const [variant] = value as GenericPodVariant[];
    selectedVariant.value = variant;
};

const variantSelected = () => {
    emit('variant-selected', selectedVariant.value!);
};

const cancel = () => {
    emit('cancel');
};

return { __sfc: true,emit, props, tableFields, productPerPage, currentPage, totalCount, searchVal, filteredItems, selectedVariant, formattedOptionName, onFilterChange, onVariantSelected, variantSelected, cancel, SelectTable }
}

})